import React from 'react';
import AccordionItem from './accordion-item';
const AccordionRoot = ({ contents }) => (React.createElement("div", { className: "accordion-container" }, contents.map(({ title, content }, i) => React.createElement(AccordionItem, { key: i, itemIndex: Number(i), openAccordions: [0], title: title, content: content }))));
export default AccordionRoot;
